import React from "react";

function CherryIcon({ className = "" }) {
  return (
    <svg
      viewBox="0 0 64 64"
      className={className}
      role="img"
      aria-label="Cherrfy"
    >
      {/* Stem */}
      <path
        d="M34 30c0-10 7-18 16-22"
        fill="none"
        stroke="#166534"
        strokeWidth="4"
        strokeLinecap="round"
      />
      {/* Leaf */}
      <path
        d="M52 8c-6 1-11 6-12 12 6-1 11-6 12-12Z"
        fill="#22c55e"
      />
      {/* Left cherry */}
      <circle cx="24" cy="40" r="10" fill="#ef4444" />
      <circle cx="20" cy="36" r="3" fill="#fecaca" opacity="0.9" />
      {/* Right cherry */}
      <circle cx="40" cy="44" r="10" fill="#fb7185" />
      <circle cx="36" cy="40" r="3" fill="#ffe4e6" opacity="0.9" />
      {/* Cherry stems */}
      <path
        d="M24 30c5 0 8 4 10 10"
        fill="none"
        stroke="#166534"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M40 34c-3 0-6 3-6 8"
        fill="none"
        stroke="#166534"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
}

function RingLoader({ className = "" }) {
  return (
    <svg
      viewBox="0 0 100 100"
      className={className}
      role="presentation"
      aria-hidden="true"
    >
      <g className="origin-center">
        {/* 4 rounded strokes around */}
        <line
          x1="50"
          y1="8"
          x2="50"
          y2="22"
          stroke="currentColor"
          strokeWidth="6"
          strokeLinecap="round"
          opacity="1"
        />
        <line
          x1="92"
          y1="50"
          x2="78"
          y2="50"
          stroke="currentColor"
          strokeWidth="6"
          strokeLinecap="round"
          opacity="0.7"
        />
        <line
          x1="50"
          y1="92"
          x2="50"
          y2="78"
          stroke="currentColor"
          strokeWidth="6"
          strokeLinecap="round"
          opacity="0.45"
        />
        <line
          x1="8"
          y1="50"
          x2="22"
          y2="50"
          stroke="currentColor"
          strokeWidth="6"
          strokeLinecap="round"
          opacity="0.25"
        />
      </g>
    </svg>
  );
}

export default function Preloader({ label, variant = "fullscreen", containerClassName = "" }) {
  const isInline = variant === "inline";
  return (
    <div
      className={
        (isInline
          ? "w-full flex items-center justify-center"
          : "min-h-screen flex items-center justify-center bg-white") +
        (containerClassName ? ` ${containerClassName}` : "")
      }
      role="status"
      aria-live="polite"
    >
      <span className="sr-only">{label || "Loading Cherrfy"}</span>
      <div className="relative flex flex-col items-center">
        <RingLoader className="h-28 w-28 text-black animate-spin motion-reduce:animate-none" />
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <CherryIcon className="h-14 w-14 drop-shadow-sm -translate-y-[2px]" />
        </div>

        {label ? (
          <div className="mt-6 text-sm font-medium text-slate-600 tracking-wide">
            {label}
          </div>
        ) : null}
      </div>
    </div>
  );
}
